import type { TypographyProps } from '@iheartjane/reefer';
import { Link, Typography } from '@iheartjane/reefer';
import { useState } from 'react';

export const TermsAndConditions = ({ children, ...rest }: TypographyProps) => {
  const [showTerms, setShowTerms] = useState(false);

  if (!children) {
    return null;
  }

  return (
    <Typography mt={8} {...rest}>
      {showTerms && children}{' '}
      <Link onClick={() => setShowTerms(!showTerms)}>
        View {showTerms ? 'less' : 'Terms & Conditions'}
      </Link>
    </Typography>
  );
};
